module.exports = __webpack_public_path__ + "static/media/file-chart-line.66fc6b89.svg";